import React from 'react';
import BackgroundImage from 'react-background-image-loader';

import loader from '../../../images/small-loader.svg';

export default (props) => {
  const {source, ...otherProps} = props;

  return <BackgroundImage src={source} placeholder={loader} {...otherProps} />;
}